import { render, staticRenderFns } from "./GrupoControl.vue?vue&type=template&id=5349bdcf&scoped=true"
import script from "./GrupoControl.vue?vue&type=script&lang=js"
export * from "./GrupoControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349bdcf",
  null
  
)

export default component.exports